export enum AccordanceState {
  DRAFT = 0,
  PENDING,
  VALID,
  FULLFILLED,
  CANCELLED,
  REJECT,
}
